var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "mt-3",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.createAddress($event)
        }
      }
    },
    [
      _c("h3", { staticClass: "card-title mb-4" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("pages.subscription.start.address.invoice_address")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("address-form", {
        attrs: {
          value: _vm.address,
          countries: _vm.countries,
          "validation-name-prefix": "invoice_address."
        },
        on: {
          input: function($event) {
            _vm.address = $event
          }
        }
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "card-title mb-4" },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("pages.subscription.start.address.delivery_address")
              ) +
              "\n        "
          ),
          _c("error-no-form-field", { attrs: { input: "delivery_address" } })
        ],
        1
      ),
      _vm._v(" "),
      _vm.copyButtonEnabled
        ? _c(
            "button",
            {
              staticClass: "btn btn-outline-dark btn-sm mb-2",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.copyInvoiceAddress($event)
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("pages.subscription.start.address.same_as_invoice")
                  ) +
                  "\n    "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "alert alert-danger shadow-sm pb-0" }, [
        _c("p", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("pages.subscription.start.address.delivery_add_lux_only")
            )
          }
        })
      ]),
      _vm._v(" "),
      _c("address-form", {
        attrs: {
          value: _vm.deliveryAddress,
          countries: _vm.countries,
          "lux-only": true,
          "validation-name-prefix": "delivery_address."
        },
        on: {
          input: function($event) {
            _vm.deliveryAddress = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("button", { staticClass: "btn btn-primary" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("pages.subscription.start.address.continue")) +
              "\n        "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }